import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
const SHAPE = {
    rect: "h-4 w-full",
    row: "h-11 w-full",
    card: "h-40 w-full",
    paragraph: "h-3 w-2/3",
};
/**
 * Skeleton — 1.6s shimmer; CLS=0.
 *
 * Requires the `@keyframes wm-shimmer` definition to be present in the host
 * app's globals.css (shipped into apps/storefront/app/globals.css,
 * apps/admin/src/index.css, and apps/playground/src/global.css by T5).
 */
export function Skeleton({ shape = "rect", className, ...rest }) {
    return (_jsx("div", { "data-slot": "skeleton", "data-shape": shape, "aria-hidden": true, className: cn("rounded-sm bg-gradient-to-r from-ink-100 via-ink-200 to-ink-100 bg-[length:200%_100%] animate-[wm-shimmer_1.6s_linear_infinite]", SHAPE[shape], className), ...rest }));
}
